import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  currentUser: string | null;
  allowedUsers: string[];
  login: (username: string, password: string) => boolean;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

const ALLOWED_USERS = ['Jacky', 'Henry', 'Kenneth', 'Linda', 'Angela', 'Crystal', 'Nicole', 'Windy'];

// 用户密码映射，格式为 username: password
const USER_PASSWORDS: Record<string, string> = {
  'Jacky': 'Jacky@123',
  'Henry': 'Henry@456',
  'Kenneth': 'Kenneth@789',
  'Linda': 'Linda@101',
  'Angela': 'Angela@102',
  'Crystal': 'Crystal@103',
  'Nicole': 'Nicole@104',
  'Windy': 'Windy@105'
};

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<string | null>(null);

  const login = (username: string, password: string): boolean => {
    // 验证用户名是否存在
    if (!ALLOWED_USERS.includes(username)) {
      return false;
    }
    
    // 验证密码是否正确
    if (USER_PASSWORDS[username] !== password) {
      return false;
    }
    
    // 登录成功
    setIsAuthenticated(true);
    setCurrentUser(username);
    return true;
  };

  const logout = () => {
    setIsAuthenticated(false);
    setCurrentUser(null);
  };

  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      currentUser,
      allowedUsers: ALLOWED_USERS,
      login,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};